<template>
  <div class="app__select">
    <div :class="{
      'app__diamond': true,
      'app__diamond--top': true,
      'app__diamond--green': currentStep == 1,
      'app__diamond--white': currentStep != 1}"></div>
    <Close />
    <div class="app__selectWrapper">
      <div class="app__selectInner">
        <StepLabel :step="step.step_number"/>
        <Steps :max-steps="maxSteps" :active-step="step.step_number" :steps="steps"/>
        <div class="app__selectBoxWrapper">
          <div class="app__selectTitle" v-html="step.title"></div>
          <div class="app__selectBoxes">
            <div class="app__selectBox" v-for="(select, index) in step.selects" v-if="step.selects">
              <img :src="select.image.path" :alt="select.image.title">
              <div class="app__selectBoxButton">
                <button class="btn btn__primary" @click="setPath(index)">{{select.label_text}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="{
      'app__diamond': true,
      'app__diamond--bottom': true,
      'app__diamond--red': currentStep == 1,
      'app__diamond--green2': currentStep != 1}"></div>
  </div>
</template>

<script>
import Close from "./../Parts/Close.vue";
import StepLabel from "./../Parts/StepLabel.vue";
import Steps from "./../Parts/Steps.vue";
import EventBus from "../../event-bus";

export default {
  props: ['steps', 'step', 'currentStep', 'maxSteps', 'maxSteps'],
  components: {
    Close,
    Steps,
    StepLabel
  },
  data: () => ({
    active: false
  }),
  mounted() {
  },
  methods: {
    setPath(index) {
      EventBus.$emit('SET_PATH', {'index': index});
      this.nextStep();
    },
    nextStep() {
      EventBus.$emit('SET_NEXT_STEP', null);
    }
  }
}
</script>
